export default __webpack_public_path__ + "static/media/solarPlusIcon.15303fc8.png";